var _path, _linearGradient, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _linearGradient6, _path7, _linearGradient7, _path8, _linearGradient8, _path9, _path0, _linearGradient9, _path1, _linearGradient0, _path10, _linearGradient1, _path11, _linearGradient10, _path12, _path13, _radialGradient, _path14, _radialGradient2, _path15, _linearGradient11, _path16, _linearGradient12, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRuby(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.217 109.422v8.547h-4.724V95.692h6.491c3.026 0 5.266.551 6.719 1.653 1.453 1.103 2.179 2.776 2.179 5.02 0 1.311-.361 2.477-1.083 3.497-.721 1.021-1.742 1.822-3.063 2.401l6.552 9.705h-5.242l-5.317-8.547h-2.512zm0-3.84h1.524c1.492 0 2.595-.25 3.306-.747.71-.498 1.066-1.28 1.066-2.346 0-1.057-.363-1.808-1.089-2.255-.726-.447-1.851-.671-3.375-.671h-1.432v6.019zm27.578 12.387l-.625-2.179h-.244c-.498.793-1.205 1.404-2.118 1.836-.915.432-1.957.647-3.124.647-2.002 0-3.509-.535-4.526-1.607-1.016-1.072-1.524-2.613-1.524-4.624v-11.108h4.648v9.95c0 1.229.218 2.151.656 2.766.436.615 1.131.921 2.086.921 1.301 0 2.24-.435 2.819-1.302.579-.869.869-2.308.869-4.319v-8.015h4.647v17.035h-3.564zm17.918-17.356c2.011 0 3.586.786 4.725 2.355 1.137 1.569 1.706 3.72 1.706 6.453 0 2.813-.587 4.992-1.759 6.535-1.173 1.545-2.771 2.316-4.793 2.316-2 0-3.57-.727-4.708-2.18h-.32l-.776 1.875h-3.551V94.26h4.647v5.516c0 .701-.062 1.823-.184 3.368h.184c1.086-1.686 2.697-2.531 4.829-2.531zm-1.493 3.719c-1.147 0-1.985.353-2.513 1.059-.528.707-.803 1.872-.823 3.498v.502c0 1.829.271 3.139.814 3.932.544.792 1.405 1.188 2.583 1.188.955 0 1.713-.44 2.278-1.318.564-.878.846-2.156.846-3.832 0-1.676-.286-2.934-.854-3.772-.568-.838-1.345-1.257-2.331-1.257zm9.021-3.398h5.088l3.215 9.584c.275.833.463 1.818.564 2.956h.092c.111-1.046.329-2.032.654-2.956l3.154-9.584h4.983l-7.207 19.214c-.661 1.777-1.602 3.108-2.826 3.992-1.225.884-2.654 1.325-4.29 1.325-.803 0-1.59-.086-2.361-.259v-3.687a7.992 7.992 0 001.828.197c.822 0 1.541-.251 2.156-.754.615-.502 1.095-1.261 1.44-2.277l.274-.839-6.764-16.912z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby-original-wordmark-a",
    gradientUnits: "userSpaceOnUse",
    x1: 143.917,
    y1: 2125.439,
    x2: 125.854,
    y2: 2157.331,
    gradientTransform: "matrix(1 0 0 -1 -47.5 2221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FB7655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FB7655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E42B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#900"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ruby-original-wordmark-a)",
    d: "M87.524 58.767L38.638 87.795l63.3-4.294 4.875-63.828z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby-original-wordmark-b",
    gradientUnits: "userSpaceOnUse",
    x1: 152.913,
    y1: 2152.229,
    x2: 129.634,
    y2: 2167.85,
    gradientTransform: "matrix(1 0 0 -1 -47.5 2221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#911209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911209"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ruby-original-wordmark-b)",
    d: "M102.041 83.457L96.6 45.905l-14.818 19.57z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby-original-wordmark-c",
    gradientUnits: "userSpaceOnUse",
    x1: 134.287,
    y1: 2124.472,
    x2: 111.008,
    y2: 2140.093,
    gradientTransform: "matrix(1 0 0 -1 -47.5 2221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#911209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911209"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ruby-original-wordmark-c)",
    d: "M102.114 83.457l-39.858-3.129-23.405 7.385z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby-original-wordmark-d",
    gradientUnits: "userSpaceOnUse",
    x1: 85.411,
    y1: 2163.54,
    x2: 89.02,
    y2: 2140.086,
    gradientTransform: "matrix(1 0 0 -1 -47.5 2221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E57252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE3B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A60003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A60003"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ruby-original-wordmark-d)",
    d: "M38.906 87.722l9.957-32.62-21.91 4.686z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby-original-wordmark-e",
    gradientUnits: "userSpaceOnUse",
    x1: 110.233,
    y1: 2185.439,
    x2: 111.563,
    y2: 2161.502,
    gradientTransform: "matrix(1 0 0 -1 -47.5 2221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E4714E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BE1A0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80D00"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ruby-original-wordmark-e)",
    d: "M81.777 65.582l-9.162-35.887-26.219 24.577z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby-original-wordmark-f",
    gradientUnits: "userSpaceOnUse",
    x1: 132.261,
    y1: 2207.563,
    x2: 136.242,
    y2: 2190.407,
    gradientTransform: "matrix(1 0 0 -1 -47.5 2221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#E46342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C82410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80D00"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ruby-original-wordmark-f)",
    d: "M104.734 30.201L79.949 9.958l-6.901 22.313z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby-original-wordmark-g",
    gradientUnits: "userSpaceOnUse",
    x1: 120.105,
    y1: 2213.604,
    x2: 137.258,
    y2: 2222.18,
    gradientTransform: "matrix(1 0 0 -1 -47.5 2221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C81F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BF0905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF0905"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ruby-original-wordmark-g)",
    d: "M93.142 2.741l-14.576 8.056-9.197-8.164z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby-original-wordmark-h",
    gradientUnits: "userSpaceOnUse",
    x1: 70.375,
    y1: 2169.518,
    x2: 71.787,
    y2: 2155.382,
    gradientTransform: "matrix(1 0 0 -1 -47.5 2221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DE4024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BF190B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF190B"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ruby-original-wordmark-h)",
    d: "M21.188 70.73l6.107-11.137-4.941-13.267z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.026 45.905l4.97 14.098 21.595-4.845 24.655-22.913 6.958-22.1-10.955-7.737-18.627 6.971c-5.868 5.458-17.256 16.258-17.667 16.461-.406.208-7.519 13.653-10.929 20.065z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby-original-wordmark-i",
    gradientUnits: "userSpaceOnUse",
    x1: 60.669,
    y1: 2151.563,
    x2: 127.036,
    y2: 2219.806,
    gradientTransform: "matrix(1 0 0 -1 -47.5 2221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#BD0012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#BD0012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#C82F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#820C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A31601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B31301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E82609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E82609"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ruby-original-wordmark-i)",
    d: "M39.477 20.581C52.196 7.97 68.592.52 74.884 6.869c6.289 6.348-.38 21.776-13.099 34.382C49.067 53.858 32.873 61.719 26.586 55.37c-6.294-6.344.173-22.183 12.891-34.789z"
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby-original-wordmark-j",
    gradientUnits: "userSpaceOnUse",
    x1: 111.505,
    y1: 2144.677,
    x2: 91.514,
    y2: 2149.611,
    gradientTransform: "matrix(1 0 0 -1 -47.5 2221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8C0C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8C0C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#990C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A80D0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80D0E"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ruby-original-wordmark-j)",
    d: "M38.906 87.709l9.879-32.724 32.811 10.541c-11.864 11.125-25.058 20.528-42.69 22.183z"
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby-original-wordmark-k",
    gradientUnits: "userSpaceOnUse",
    x1: 145.839,
    y1: 2168.67,
    x2: 128.08,
    y2: 2184.586,
    gradientTransform: "matrix(1 0 0 -1 -47.5 2221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7E110B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7E110B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9E0C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E0C00"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ruby-original-wordmark-k)",
    d: "M73.289 32.181l8.423 33.363c9.91-10.419 18.804-21.621 23.159-35.476l-31.582 2.113z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby-original-wordmark-l",
    gradientUnits: "userSpaceOnUse",
    x1: 152.364,
    y1: 2197.874,
    x2: 143.518,
    y2: 2207.331,
    gradientTransform: "matrix(1 0 0 -1 -47.5 2221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79130D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79130D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9E120B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E120B"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ruby-original-wordmark-l)",
    d: "M104.785 30.236c3.371-10.174 4.148-24.768-11.746-27.477L79.996 9.963l24.789 20.273z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E1209",
    d: "M21.188 70.583c.467 16.789 12.581 17.04 17.741 17.188l-11.92-27.837-5.821 10.649z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "ruby-original-wordmark-m",
    cx: 130.847,
    cy: 2184.281,
    r: 21.762,
    gradientTransform: "matrix(1 0 0 -1 -47.5 2221)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7E0E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E0E08"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ruby-original-wordmark-m)",
    d: "M73.337 32.232c7.615 4.68 22.96 14.08 23.271 14.253.484.272 6.617-10.342 8.008-16.34l-31.279 2.087z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "ruby-original-wordmark-n",
    cx: 100.707,
    cy: 2155.602,
    r: 28.932,
    gradientTransform: "matrix(1 0 0 -1 -47.5 2221)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A30C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A30C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#800E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800E08"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ruby-original-wordmark-n)",
    d: "M48.772 54.986l13.207 25.48c7.81-4.235 13.924-9.395 19.526-14.922L48.772 54.986z"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby-original-wordmark-o",
    gradientUnits: "userSpaceOnUse",
    x1: 80.214,
    y1: 2133.309,
    x2: 73.005,
    y2: 2157.766,
    gradientTransform: "matrix(1 0 0 -1 -47.5 2221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8B2114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8B2114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9E100A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B3100C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3100C"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ruby-original-wordmark-o)",
    d: "M26.957 59.969l-1.872 22.282c3.532 4.823 8.389 5.241 13.485 4.866-3.687-9.175-11.051-27.521-11.613-27.148z"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ruby-original-wordmark-p",
    gradientUnits: "userSpaceOnUse",
    x1: 135.518,
    y1: 2214.356,
    x2: 151.68,
    y2: 2207.222,
    gradientTransform: "matrix(1 0 0 -1 -47.5 2221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B31000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#B31000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#910F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#791C12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#791C12"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ruby-original-wordmark-p)",
    d: "M79.919 10.02l26.237 3.683c-1.401-5.935-5.701-9.763-13.03-10.961L79.919 10.02z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuby);
export default __webpack_public_path__ + "static/media/ruby.34d2a65c356960988a70d2835e60a872.svg";
export { ForwardRef as ReactComponent };